import classNames from "classnames";
import PropTypes from "prop-types";
import React, { useState } from "react";

const InfoPanel = ({
  title,
  summary,
  action,
  expandable,
  actionContents,
  children,
  classes
}) => {
  const [expanded, setExpanded] = useState(false);
  const [inActionMode, setInActionMode] = useState(false);

  const toggleExpansion = () => {
    setExpanded(!expanded);
  };

  const toggleAction = () => {
    setInActionMode(!inActionMode);
  };

  const callActionFunction = () => {
    action.actionFunc && action.actionFunc();
    setInActionMode(false);
  };

  let panelBody;
  let hideButton;

  if (inActionMode) {
    panelBody = action.renderPanel || actionContents;
    hideButton = action.renderHide;
  } else {
    panelBody = summary;
    hideButton = "show details";
    if (expanded) {
      panelBody = children;
      hideButton = "hide details";
    }
  }

  const wrapperClass = classNames(
    "bg-white p-1 mb-2 w-full",
    "rounded-md border-solid border-2 border-en-gray-100"
  );

  const titleClass = classNames(
    "flex justify-between items-center",
    "mx-2 py-2 font-bold text-lg",
    classes?.titleClass
  );

  return (
    <div className={wrapperClass}>
      {/* title */}
      <div className={titleClass}>
        <span>{title}</span>
        {inActionMode && (
          <div
            className="text-black text-sm cursor-pointer"
            onClick={toggleAction}
          >
            <span className="fas fa-times mr-2" />
          </div>
        )}

        {!inActionMode && action && (
          <div
            className={classNames(
              "cursor-pointer font-bold px-4 rounded focus:outline-none",
              "font-gotham hover:shadow-md text-white bg-en-gray-700 gradient-dark py-2",
              classes?.buttonClass
            )}
            onClick={toggleAction}
          >
            {action.icon && <span className={`fas ${action.icon} mr-2`} />}
            {action.text}
          </div>
        )}
      </div>
      <hr />
      <div className={classNames("mt-2 mx-2", classes?.bodyClass)}>
        <div>
          {inActionMode && actionContents
            ? actionContents({ completeAction: toggleAction })
            : panelBody}
        </div>
      </div>

      {((children && expandable) || inActionMode) && (
        <div
          className="text-gray-400 text-sm flex justify-end cursor-pointer"
          onClick={inActionMode ? callActionFunction : toggleExpansion}
        >
          {hideButton}
        </div>
      )}
    </div>
  );
};

InfoPanel.propTypes = {
  title: PropTypes.string,
  summary: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  action: PropTypes.shape({
    text: PropTypes.string,
    icon: PropTypes.string,
    renderPanel: PropTypes.element,
    renderHide: PropTypes.element,
    actionFunc: PropTypes.func
  }),
  expandable: PropTypes.bool,
  actionContents: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  classes: PropTypes.object
};

export default InfoPanel;
